<div matDialogTitle>Asset Limit</div>
<mat-dialog-content>
    <div>{{message}}</div>
</mat-dialog-content>
<mat-slide-toggle [(ngModel)]="allowUnlimited">Do not limit number of assets displayed</mat-slide-toggle>
<div>
    <br>
    <p style="color: #ff5722; max-width: 480px">WARNING: This setting may significantly impact load time. Refresh the page to revert to default setting.</p>
</div>
<mat-dialog-actions classs="layout-row-end-none" style="justify-content: end;gap:20px">
    <button mat-raised-button (click)="dialogRef.close({})">Cancel</button>
    <button mat-raised-button (click)="save()">Confirm</button>
</mat-dialog-actions>

